import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { FieldEditorV2Component } from '../../base-template-editor-v2/field-editor-v2/field-editor-v2.component';
import { InlineEditV2Directive } from '../../base-template-editor-v2/inline-edit/inline-edit-v2.directive';
import { BaseComponent } from '../../common/BaseComponent';
import { Helper } from '../../../../utils/helper';
import {
  DisclaimerInitModel,
  DisclaimerInitVariables,
  DisclaimerModel,
  DisclaimerVariables,
} from '../../../../models/email-template/disclaimer.interface';

/**
 * Mockup-styled Disclaimer block - a drop-in replacement for app-disclaimer
 * in block-renderer-v2 (same [block]/[isPreview] inputs and outputs), so it
 * covers both the center-canvas summary (isPreview=true) and the
 * right-panel edit form (isPreview=false). Reuses the real, unmodified
 * app-field-editor-v2 and app-pin sub-components and the exact same
 * DisclaimerVariables field name - only the surrounding layout is new. Same
 * single-text-field pattern as Only Intro (see only-intro-v2), just small
 * italic legal-text styling instead of body-text (matches the mockup's own
 * .cr-disclaimer-text - 11px italic, left-aligned, no heading/CTA).
 */
@Component({
  selector: 'app-disclaimer-v2',
  imports: [CommonModule, ReactiveFormsModule, FieldEditorV2Component, InlineEditV2Directive],
  templateUrl: './disclaimer-v2.component.html',
  styleUrl: './disclaimer-v2.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class DisclaimerComponentV2 extends BaseComponent implements OnInit {
  @Input() block: DisclaimerModel = new DisclaimerInitModel();
  @Input() isPreview = false;
  @Input() disabled = false;

  @Output() blockData = new EventEmitter<any>();
  @Output() removeBlockEvent = new EventEmitter<string | null>();

  ngOnInit() {
    if (Helper.isEmpty(this.block.variables!)) {
      this.block.variables = new DisclaimerInitVariables();
    }
  }

  disclaimerPlaceholder = 'Enter Disclaimer';

  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId);
  }

  onChange(value: any, fieldName: keyof DisclaimerVariables) {
    if (this.block.variables) {
      (this.block.variables as any)[fieldName] = value;
      this.blockData.emit(this.block);
    }
  }
}
